import { basicCreator, Validator } from 'redux/ducks/helpers';

const constForName = name => `go4ellis/Registration/${name}`;

// Actions
// ========================================================
export const FIELD_UPDATE = constForName('FIELD_UPDATE');
export const FIELD_VALIDATE = constForName('FIELD_VALIDATE');
export const RESET_REGISTRATION = constForName('RESET_REGISTRATION');
export const SET_ROLE = constForName('SET_ROLE');
export const SUBMIT_PROFILE = constForName('SUBMIT_PROFILE');
export const SUBMIT_PROFILE_ERROR = constForName('SUBMIT_PROFILE_ERROR');
export const SUBMIT_PROFILE_SUCCESS = constForName('SUBMIT_PROFILE_SUCCESS');

// Post Event Registration
export const POST_EVENT_ACCOUNT_FIELD_VALIDATE = constForName('POST_EVENT_ACCOUNT_FIELD_VALIDATE');
export const POST_EVENT_CONTACT_FIELD_VALIDATE = constForName('POST_EVENT_CONTACT_FIELD_VALIDATE');
export const POST_EVENT_PROFILE_FIELD_VALIDATE = constForName('POST_EVENT_PROFILE_FIELD_VALIDATE');
export const POST_EVENT_SHIFT_DETAILS_FIELD_VALIDATE = constForName(
  'POST_EVENT_SHIFT_DETAILS_FIELD_VALIDATE'
);
export const POST_EVENT_PASSWORD_FIELD_VALIDATE = constForName('POST_EVENT_PASSWORD_FIELD_VALIDATE');
export const CONTRACT_INFO_FIELD_VALIDATE = constForName('CONTRACT_INFO_FIELD_VALIDATE');

// Creates an Account and starts event posting flow
export const REGISTRATION_POST_EVENT = constForName('REGISTRATION_POST_EVENT');
export const REGISTRATION_POST_EVENT_ERROR = constForName('REGISTRATION_POST_EVENT_ERROR');
export const REGISTRATION_POST_EVENT_SUCCESS = constForName('REGISTRATION_POST_EVENT_SUCCESS');

// Sends an email to us
export const CONTRACT_SUBMIT = constForName('CONTRACT_SUBMIT');
export const CONTRACT_SUBMIT_ERROR = constForName('CONTRACT_SUBMIT_ERROR');
export const CONTRACT_SUBMIT_SUCCESS = constForName('CONTRACT_SUBMIT_SUCCESS');

export const CHECK_ACCOUNT = constForName('CHECK_ACCOUNT');
export const CHECK_ACCOUNT_ERROR = constForName('CHECK_ACCOUNT_ERROR');
export const CHECK_ACCOUNT_SUCCESS = constForName('CHECK_ACCOUNT_SUCCESS');

export const PARENT_FIELD_VALIDATE = constForName('PARENT_FIELD_VALIDATE');
export const PATIENT_FIELD_VALIDATE = constForName('PATIENT_FIELD_VALIDATE');

export const VALIDATE_INVITATION_TOKEN = constForName('VALIDATE_INVITATION_TOKEN');
export const VALIDATE_INVITATION_TOKEN_SUCCESS = constForName('VALIDATE_INVITATION_TOKEN_SUCCESS');
export const VALIDATE_INVITATION_TOKEN_ERROR = constForName('VALIDATE_INVITATION_TOKEN_ERROR');

export const ACCEPT_INVITATION = constForName('ACCEPT_INVITATION');
export const ACCEPT_INVITATION_SUCCESS = constForName('ACCEPT_INVITATION_SUCCESS');
export const ACCEPT_INVITATION_ERROR = constForName('ACCEPT_INVITATION_ERROR');

// Reducer Functions
// ========================================================
const errorReducer = (state, payload) => ({ ...state, error: payload });

const fieldUpdateReducer = (state, payload) => ({
  ...state,
  user: { ...state.user, [payload.field]: payload.value },
});

const fieldValidateReducer = (state, payload) => {
  const validation = { ...state.validation };
  validation['errors'] = validation.validator.validate(state.user, payload);
  validation['allValidated'] = validation.validator.allValidated();
  validation['validAccount'] = Object.keys(validation['errors']).length === 0 && validation.allValidated;

  return { ...state, validation };
};

export const postEventFieldValidateReducer = (validation, state, payload) => {
  validation['errors'] = validation.validator.validate(state.user, payload);
  validation['allValidated'] = validation.validator.allValidated();
  validation['valid'] = Object.keys(validation['errors']).length === 0 && validation.allValidated;
  return validation;
};

const postEventAccountFieldValidateReducer = (state, payload) => {
  const validation = { ...state.postEventAccountValidation };
  return {
    ...state,
    postEventAccountValidation: postEventFieldValidateReducer(validation, state, payload),
  };
};

const postEventContactFieldValidateReducer = (state, payload) => {
  const validation = { ...state.postEventContactValidation };
  return {
    ...state,
    postEventContactValidation: postEventFieldValidateReducer(validation, state, payload),
  };
};

const postEventProfileFieldValidateReducer = (state, payload) => {
  const validation = { ...state.postEventProfileValidation };
  return {
    ...state,
    postEventProfileValidation: postEventFieldValidateReducer(validation, state, payload),
  };
};

function postEventShiftDetailsFieldValidateReducer(state, payload) {
  const key =
    state.user.postEventMasterType === 'sports'
      ? 'postSportEventShiftDetailsValidation'
      : 'postCovidEventShiftDetailsValidation';
  const validation = { ...state[key] };
  return {
    ...state,
    [key]: postEventFieldValidateReducer(validation, state, payload),
  };
}

const postEventPasswordFieldValidateReducer = (state, payload) => {
  const validation = { ...state.postEventPasswordValidation };
  return {
    ...state,
    postEventPasswordValidation: postEventFieldValidateReducer(validation, state, payload),
  };
};

const contractInfoFieldValidateReducer = (state, payload) => {
  const validation = { ...state.contractInfoValidation };
  return {
    ...state,
    contractInfoValidation: postEventFieldValidateReducer(validation, state, payload),
  };
};

const parentFieldValidateReducer = (state, payload) => {
  const validation = { ...state.parentValidation };
  validation['errors'] = validation.validator.validate(state.user, payload);
  validation['allValidated'] = validation.validator.allValidated();
  validation['validAccount'] =
    state.validInvitationToken && Object.keys(validation['errors']).length === 0 && validation.allValidated;

  return {
    ...state,
    parentValidation: validation,
  };
};

const patientFieldValidateReducer = (state, payload) => {
  const validation = { ...state.patientValidation };
  validation['errors'] = validation.validator.validate(state.user, payload);
  validation['allValidated'] = validation.validator.allValidated();
  validation['validAccount'] =
    state.validInvitationToken && Object.keys(validation['errors']).length === 0 && validation.allValidated;

  return {
    ...state,
    patientValidation: validation,
  };
};

const resetRegistrationReducer = state => {
  return new DefaultState();
};

const setRoleReducer = (state, payload) => {
  return {
    ...state,
    role: payload,
    user: {
      ...state.user,
      type: payload,
    },
  };
};

const submitProfileReducer = (state, payload) => {
  return {
    ...state,
    user: { ...state.user, ...payload },
  };
};

const validateInvitationTokenReducer = (state, user) => {
  return {
    ...state,
    validInvitationToken: true,
    ...state.user,
    ...user,
  };
};

// Action Creators
// ========================================================
export const registrationFieldUpdate = (field, value) => ({ type: FIELD_UPDATE, payload: { field, value } });
export const contractSubmit = history => ({ type: CONTRACT_SUBMIT, payload: { history } });
export const registrationFieldValidate = basicCreator(FIELD_VALIDATE);
export const parentRegistrationFieldValidate = basicCreator(PARENT_FIELD_VALIDATE);
export const postEventAccountFieldValidate = basicCreator(POST_EVENT_ACCOUNT_FIELD_VALIDATE);
export const postEventContactFieldValidate = basicCreator(POST_EVENT_CONTACT_FIELD_VALIDATE);
export const postEventProfileFieldValidate = basicCreator(POST_EVENT_PROFILE_FIELD_VALIDATE);
export const postEventShiftDetailsFieldValidate = basicCreator(POST_EVENT_SHIFT_DETAILS_FIELD_VALIDATE);
export const postEventPasswordFieldValidate = basicCreator(POST_EVENT_PASSWORD_FIELD_VALIDATE);
export const contractInfoFieldValidate = basicCreator(CONTRACT_INFO_FIELD_VALIDATE);
export const checkAccountExists = basicCreator(CHECK_ACCOUNT);
export const patientRegistrationFieldValidate = basicCreator(PATIENT_FIELD_VALIDATE);
export const resetRegistration = basicCreator(RESET_REGISTRATION);
export const setRole = basicCreator(SET_ROLE);
export const submitProfile = basicCreator(SUBMIT_PROFILE);
export const registrationPostEvent = basicCreator(REGISTRATION_POST_EVENT);
export const validateInvitationToken = (token, location) => ({
  type: VALIDATE_INVITATION_TOKEN,
  payload: { token, location },
});
export const acceptInvitation = (token, history, location) => ({
  type: ACCEPT_INVITATION,
  payload: { token, history, location },
});

export const HEAR_ABOUT_US_ADDITIONAL_OPTIONS = [
  'Conference',
  'Recommended by an Athletic Trainer',
  'Recommended by friend/colleague',
  'Other',
];

export const HEAR_ABOUT_US_OPTIONS = [
  'Mailer',
  'Email',
  'Google/Search Engines',
  'Twitter',
  'Instagram',
  'Facebook',
  'Blog or Publication',
  ...HEAR_ABOUT_US_ADDITIONAL_OPTIONS,
];

export const EXPECTED_HOURS_OPTIONS = ['Under 50', '50-100', '100-150', '150+'];

const DEFAULT_USER = {
  postEventMasterType: 'contract',
  email: `eotest+${Date.now()}@go4.io`,
  firstName: 'Event',
  lastName: 'Operator',
  phone: '+16692009568',
  password: 'password',
  passwordConfirmation: 'password',
  companyName: 'duty labs',
  organizationWebsite: 'https://www.dutylabs.ro',
  city: 'san jose',
  state: 'ca',
  addressZip: '95122',
  eventName: '[test event]',
  sportId: '1',
  genderId: '1',
  eventTypeId: '1',
  eventParticipantNumbersId: '1',
  settingId: '1',
  terms: 'true',
  type: 'EventOperator',
  userPersona: 'Single',
};

// Reducer
// ========================================================
export class DefaultState {
  role = null;
  user =
    process.env.NODE_ENV === ''
      ? DEFAULT_USER
      : {
          postEventMasterType: '',
          email: '',
          firstName: '',
          lastName: '',
          phone: '',
          password: '',
          passwordConfirmation: '',
          companyName: '',
          organizationWebsite: '',
          city: '',
          state: '',
          addressZip: '',
          eventName: '',
          sportId: '',
          genderId: '',
          eventTypeId: '',
          eventParticipantNumbersId: '',
          settingId: '',
          hearAboutUsSource: '',
          expectedYearlyStaffedHours: '',
          hearAboutUsDetails: '',
          type: 'EventOperator',
          defaultEventSettingId: '',
          userPersona: '',
        };
  validation = {
    valid: false,
    allValidated: false,
    errors: {},
    validator: new Validator({
      email: { required: true, email: true },
      password: { required: true, minLength: 8 },
      passwordConfirmation: { matches: 'password', required: true },
      terms: { hasValue: true },
    }),
  };
  postEventAccountValidation = {
    valid: false,
    allValidated: false,
    errors: {},
    validator: new Validator({
      firstName: { required: true },
      lastName: { required: true },
      email: { required: true, email: true },
      phone: { required: true, minLength: 10 },
      password: { required: true, minLength: 8 },
      passwordConfirmation: { matches: 'password', required: true },
      terms: { hasValue: true },
      hearAboutUsSource: { required: true, hasDetailsWhenOther: 'hearAboutUsDetails' },
    }),
  };
  postEventContactValidation = {
    valid: false,
    allValidated: false,
    errors: {},
    validator: new Validator({
      email: { required: true, email: true },
      firstName: { required: true },
      lastName: { required: true },
      phone: { required: true, minLength: 10 },
    }),
  };
  postEventProfileValidation = {
    valid: false,
    allValidated: false,
    errors: {},
    validator: new Validator({
      companyName: { required: true },
      organizationWebsite: { website: true },
    }),
  };
  contractInfoValidation = {
    valid: false,
    allValidated: false,
    errors: {},
    validator: new Validator({
      startDate: { required: true },
      endDate: { required: true, dateGreaterThanOrEqual: 'startDate' },
    }),
  };
  postSportEventShiftDetailsValidation = {
    valid: false,
    allValidated: false,
    errors: {},
    validator: new Validator({
      eventName: { required: true },
      sportId: { required: true },
      genderId: { required: true },
      ageBracketIds: { required: true },
      eventTypeId: { required: true },
      eventParticipantNumbersId: { required: true },
    }),
  };
  postCovidEventShiftDetailsValidation = {
    valid: false,
    allValidated: false,
    errors: {},
    validator: new Validator({
      eventName: { required: true },
      settingTypeId: { required: true },
      eventParticipantNumbersId: { required: true },
    }),
  };
  postEventPasswordValidation = {
    valid: false,
    allValidated: false,
    errors: {},
    validator: new Validator({
      password: { required: true, minLength: 8 },
      passwordConfirmation: { matches: 'password', required: true },
      terms: { hasValue: true },
    }),
  };
  parentValidation = {
    validAccount: false,
    allValidated: false,
    errors: {},
    validator: new Validator({
      password: { required: true, minLength: 8 },
      passwordConfirmation: { matches: 'password', required: true },
      firstName: { required: true },
      lastName: { required: true },
      addressZip: { required: true },
      terms: { hasValue: true },
    }),
  };
  patientValidation = {
    validAccount: false,
    allValidated: false,
    errors: {},
    validator: new Validator({
      password: { required: true, minLength: 8 },
      passwordConfirmation: { matches: 'password', required: true },
      firstName: { required: true },
      lastName: { required: true },
      addressZip: { required: true },
      terms: { hasValue: true },
    }),
  };
}

export default function reducer(state = new DefaultState(), action = {}) {
  switch (action.type) {
    case FIELD_UPDATE:
      return fieldUpdateReducer(state, action.payload);
    case FIELD_VALIDATE:
      return fieldValidateReducer(state, action.payload);
    case POST_EVENT_ACCOUNT_FIELD_VALIDATE:
      return postEventAccountFieldValidateReducer(state, action.payload);
    case POST_EVENT_CONTACT_FIELD_VALIDATE:
      return postEventContactFieldValidateReducer(state, action.payload);
    case POST_EVENT_PROFILE_FIELD_VALIDATE:
      return postEventProfileFieldValidateReducer(state, action.payload);
    case POST_EVENT_SHIFT_DETAILS_FIELD_VALIDATE:
      return postEventShiftDetailsFieldValidateReducer(state, action.payload);
    case POST_EVENT_PASSWORD_FIELD_VALIDATE:
      return postEventPasswordFieldValidateReducer(state, action.payload);
    case CONTRACT_INFO_FIELD_VALIDATE:
      return contractInfoFieldValidateReducer(state, action.payload);
    case PARENT_FIELD_VALIDATE:
      return parentFieldValidateReducer(state, action.payload);
    case PATIENT_FIELD_VALIDATE:
      return patientFieldValidateReducer(state, action.payload);
    case RESET_REGISTRATION:
      return resetRegistrationReducer(state);
    case SET_ROLE:
      return setRoleReducer(state, action.payload);
    case SUBMIT_PROFILE_SUCCESS:
      return submitProfileReducer(state, action.payload);
    case SUBMIT_PROFILE_ERROR:
      return errorReducer(state, action.payload);
    case VALIDATE_INVITATION_TOKEN_SUCCESS:
      return validateInvitationTokenReducer(state, {
        user: action.payload.parent ? action.payload.parent : action.payload.patient,
      });
    default:
      return state;
  }
}
